<div class="loader">
  <div class="lds-css ng-scope"><div style="width:100%;height:100%" class="lds-rolling"><div></div></div></div>
</div>

<div class="loader-mini" *ngIf="type=='mini'">
  <div class="lds-css ng-scope"><div style="width:100%;height:100%" class="lds-rolling"><div></div></div></div>
</div>

<div class="sidebar-loader" *ngIf="type=='sidebar'">
  <div class="lds-css ng-scope"><div style="width:100%;height:100%" class="lds-rolling"><div></div></div></div>
</div>
